"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BsMediaCard = void 0;
const react_1 = __importDefault(require("react"));
const components_common_router_link_1 = require("@hotelplan/components.common.router-link");
const bs_media_card_styles_1 = require("./bs-media-card.styles");
const MediaItemWrapper = ({ testId, openMethod, link, onClick, children, className }) => {
    const wrapperProps = {
        className,
        onClick,
        children,
        'data-id': testId,
    };
    return link ? (react_1.default.createElement(components_common_router_link_1.RouterLink, Object.assign({}, link, { passHref: true }),
        react_1.default.createElement(bs_media_card_styles_1.BsMediaCardLink, Object.assign({ target: openMethod }, wrapperProps)))) : (react_1.default.createElement(bs_media_card_styles_1.BsMediaCardWrapper, Object.assign({}, wrapperProps)));
};
const BsMediaCard = ({ title, subTitle, link, openMethod, testId, onClick = () => void 0, className, imageElement, children, }) => {
    return (react_1.default.createElement(MediaItemWrapper, { link: link, openMethod: openMethod, testId: testId, onClick: onClick, className: className },
        imageElement,
        react_1.default.createElement(bs_media_card_styles_1.BsMediaCardContent, { title: title, subTitle: subTitle, className: "media-card-content" }, children)));
};
exports.BsMediaCard = BsMediaCard;
//# sourceMappingURL=bs-media-card.js.map